module.exports = __webpack_public_path__ + "img/ar_position.40837df9.jpg";